import { useState, useEffect, useRef } from "react";
import { Row, Col, message, Tooltip, Modal, Spin, Layout, Progress, Input, Card, Button, Tag } from "antd";
import {
  LoadingOutlined,
  ArrowLeftOutlined,
  MoreOutlined,
  CustomerServiceOutlined,
  SearchOutlined,
  CloseOutlined,
  EditOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import _, { get } from "lodash";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import All from "../../../assets/images/all.svg";
import ParkedOrder from "../../../assets/images/parkedOrder.svg";
import InProgress from "../../../assets/images/inProgress.svg";
import Pending from "../../../assets/images/pending.svg";
import Prepared from "../../../assets/images/prepared.svg";
import Completed from "../../../assets/images/completed.svg";
import BackIcon from "../../../assets/images/backIcon.svg";
import Logo from "../../../assets/images/logo-without-bg.png";
import AddUser from "../../../assets/images/userAdd.svg";
import CustomerSearch from "../../../assets/images/search.png";
import CustomerIcon from "../../../assets/images/userId.svg";
import View from "../../../assets/images/view.svg";
import Logout from "../../../assets/images/logout.png";
import leftLoading from "../../../assets/images/opo.gif";
import SyncIcon from "../Retail/SvgComponent/SyncIcon";
import TableDineIN from "./SvgComponents/TableDineIn";
import TakeAway from "./SvgComponents/TakeAway";
import TableMenu from "./SvgComponents/TableMenu";
import TableCustomer from "./SvgComponents/TableCustomer";
import CashManagementIcon from "../Retail/SvgComponent/CashManagementIcon";
import unlinkTill from "../../../assets/images/unlink-icon.svg";
import openDrawerIcon from "../../../assets/images/openDrawer.svg";
import printerIcon from "../../../assets/images/printerIcon.svg";
import data from "../../../constants/retailPos.json";
import db from "../../../database";
import { clock } from "../../../utility/clock";
import RestaurantModals from "./RestaurantModals";
import moment from "moment";
import { kotPrinter } from "../../../lib/printer/kotPrinter";
import CWKOTPrinter from "../../../lib/printer/CWKotPrinter";
import { SyncData } from "./Tables-Management/SyncData";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import MenuLayout from "./MenuLayout";
import CashManagement from "./cashManagement";
import OrderListComponent from "./OrderListComponent";
import { useGlobalContext } from "../../../lib/auth/globalStore";
import { processSync } from "../../Sync/syncData";
import TableManagement from "./Tables-Management/tables";
import TableOrder from "./SvgComponents/TableOrder";
import CustomersComponent from "./CustomersComponent";
import HomeDeliveryComponent from "./HomeDeliveryComponent";
import { useTranslation } from "react-i18next";
import RetailModals from "../Retail/RetailModals";
import { getMultilingualText } from "../../../utility/getMultilingualText ";
import { useEventBus } from "../../../lib/hooks/EventBusProvider";
import { timeStamp } from "../../../utility/clock";
import { getNewOmsOrder, updateOMSOrderStatus, fetchOccupiedTablesData, fetchRestaurantTables, processRestaurantTables, updateTableDataWithOccupiedInfo } from "../../../services";
import messages from "../../../errors/messages.en-IN.json";
import salesReportIcon from "../../../assets/images/salesReportIcon.svg";
import { getWorkflowData } from "../../../utility/getWorkflowData";

const FBLayout = (props) => {
  const {
    salesReportCWHCPrinter,
    salesReportPrinter,
    filteredPaymentMethods,
    getFilteredPaymentMethods,
    handleSelectedSaleTypeForProducts,
    selectedSaleType,
    setSelectedSaleType,
    saleTypeProducts,
    setSaleTypeProducts,
    cart,
    setCart,
    decreaseProductQty,
    deleteCart,
    setGiftCardData,
    deleteProduct,
    increaseProductQty,
    openDisplayParkedBillModal,
    openPaymentModal,
    orderType,
    parkedList,
    selectProductCategory,
    selectProductInCart,
    selectedProductInCart,
    setSelectedProductInCart,
    setDisplayCustomerSearch,
    tillData,
    currencyType,
    setManualDiscountInput,
    manualDiscountModalVisible,
    setManualDiscountModalVisible,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    setAddCashFlag,
    requestPayment,
    setSelectedPaymentMethod,
    selectedPaymentMethod,
    amount,
    setAmount,
    setNumb,
    processOrder,
    handleAmount,
    handleCashPayment,
    setCashAddInFlag,
    pickProduct,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    documentSequence,
    setDocumnetSequence,
    productsData,
    setProductsData,
    allProductCategories,
    orderTypeSelection,
    setOrderTypeSelection,
    addDefinedProductWithAddons,
    setManualDiscountTypes,
    manualDiscountForm,
    setSelectedManualDiscountTypeValue,
    isSaleTypeFlag,
    setIsSaleTypeFlag,
    showProducts,
    setShowProducts,
    keyValue,
    setKeyValue,
    tableCards,
    setTableCards,
    clearCart,
    splitCarts,
    setSplitCarts,
    dynamicForm,
    setDynamicForm,
    setSaleType,
    saleType,
    selectedItemsModalOpen,
    setSelectedItemsModalOpen,
    notesValue,
    setNotesValue,
    selectedProductForNotes,
    setIsInputFocused,
    keyboardRef,
    setSelectedProductForNotes,
    searchOrderHistory,
    orderHistoryDetails,
    setOrderHistoryDetails,
    getSalesHistoryData,
    isPrintModeXML,
    upsertPOSLog,
    setFiltersFlag,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    searchHistoryInput,
    setSearchhistoryInput,
    ordersCopy,
    dateRef,
    filtersFlag,
    callCenterVisible,
    setCallCenterVisible,
    removeCutomer,
    showAddNewCustomerFields,
    setProductSearchInput,
    customerId,
    setCloseCustomerFlag,
    setCustomerSearchResults,
    setCustomerSearchInput,
    handleCustomerSearch,
    showEditOldCustomerFields,
    setEditFlag,
    setKeyboardInputFields,
    keyboardInputFields,
    displayCustomerSearch,
    isCallCenterFlow,
    setIsCallCenterFlow,
    showCallCenterPage,
    setShowCallCenterPage,
    holdQueue,
    setHoldQueue,
  } = props;
  const history = useHistory();
  const { t } = useTranslation();
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const { globalStore, setGlobalStore } = useGlobalContext();
  const { percent, promotionPercentage, productPercentage, productCategoryPercentage } = globalStore;
  const tillaccess = JSON.parse(tillData?.tillAccess?.userAccessController);
  const accessController = JSON.parse(tillData?.tillAccess?.cwrTill?.accessController);
  // SAVING BILL BLOCK START //
  const storedLocatedList = JSON.parse(localStorage.getItem("locatedList"));
  const initialLocatedList = storedLocatedList ? storedLocatedList : [];
  const [locatedList, setLocatedList] = useState(initialLocatedList);
  const [selectedTable, setSelectedTable] = useState(
    JSON.parse(localStorage.getItem("tableName")) !== "null" ? JSON.parse(localStorage.getItem("tableName")) : history?.location?.state || ""
  );
  const [orderedData, setOederedData] = useState([]);
  const [tempProducts, setTempProducts] = useState([]);
  const [orderCanceled, setOrderCanceled] = useState(false);
  const [productsList, setProductsList] = useState([]);
  const [paymentVisible, setPaymentVisible] = useState(false);
  const [showOrderCompleteFlag, setShowOrderCompleteFlag] = useState(false);
  const [syncLoad, setSyncLoad] = useState(false);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [clock1, setClock1] = useState(clock());
  // const [showProducts, setShowProducts] = useState(false);
  const [occupiedDataTablesData, setOcupiedTablesData] = useState([]);
  const [reservedTablesData, setReservedTablesData] = useState([]);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [tableList, setTableList] = useState([]);
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const userPreferences = JSON.parse(localStorage.getItem("userPreferences")) || { dateFormat: "DD-MM-YYYY", dateTimeFormat: "DD-MM-YYYY HH:mm:ss" };
  const posConfig = JSON.parse(localStorage.getItem("posConfig"));
  const { dispatchEvent } = useEventBus();
  const userData = JSON.parse(localStorage.getItem("userData"));
  const tillValue = JSON.parse(localStorage.getItem("tillValue"));
  const defaultCustomer = tillData.tillAccess.csBunit.b2cCustomer;
  const [showSplitBill, setShowSplitBill] = useState(false);
  const [splitBillScreen, setSplitBillScreen] = useState(false);
  const [numSplits, setNumSplits] = useState(2);
  const [showAllItems, setShowAllItems] = useState(true);
  const [isSplitBill, setIsSplitBill] = useState(false);
  const [currentSplitIndex, setCurrentSplitIndex] = useState(0);
  const [recordState, setRecardState] = useState("");
  const [removeSplit, setRemoveSplit] = useState([]);
  const CWHardwareController = tillData?.tillAccess?.cwrTill?.printTemplate?.cwController === "Y" ? true : false;
  const [mainTableData, setMainTableData] = useState([]);
  const tillDocumentSequence = parseFloat(localStorage.getItem("documentSequence"));
  const [selectedProducts, setSelectedproducts] = useState([]);
  const [showSendToKitchen, setShowSendToKitchen] = useState(false);
  const [guestsModalFlag, setGuestsModalFlag] = useState(false);
  const [noOfPersons, setNumberOfPersons] = useState("");
  const [priorityBtn, setPriorityBtn] = useState(false);
  const [orderFlags, setOrderFlags] = useState([]);
  const [loading, setLoading] = useState(false);

  const getDefaultSaleType = async () => {
    const saleData = await db.posSaletypes.toArray();
    const defaultSale = saleData.find((sale) => sale?.cwrSaletype?.isdefault === "Y");
    if (defaultSale) return defaultSale;
    const dineInSale = saleData.find((sale) => sale?.cwrSaletype?.value === "DI");
    if (dineInSale) return dineInSale;
    const takeAwaySale = saleData.find((sale) => sale?.cwrSaletype?.value === "TA");
    if (takeAwaySale) return takeAwaySale;
    return saleData[0]; // Fallback to first sale type if none found
  };

  useEffect(async () => {
    const defaultSaleType = await getDefaultSaleType();
    const cartData = {
      items: [],
      couponInput: [],
      total: 0,
      tax: 0,
      discount: 0,
      paid: 0,
      change: 0,
      totalQty: 0,
      roundOff: 0,
      payments: [],
      redemptionPoints: 0,
      accumulationPoints: 0,
      creditAmount: 0,
      sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
      referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
      giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      customer: defaultSaleType.customer?.b2cCustomerId ? defaultSaleType.customer : tillData.tillAccess.csBunit.b2cCustomer,
      couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
      salesRepId: null,
      cardPaymentData: {},
      documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
      userName: userData.user,
      tillName: tillValue?.name,
      subTotal: 0,
      itemsSummery: {},
      amountInWords: "",
      groupedItemsByTaxRate: {},
      serviceCharge: 0,
      tip: 0,
      deiveryCharge: 0,
      packingCharge: 0,
    };
    localStorage.setItem("cartObj", JSON.stringify(cartData));
    setCart(cartData);
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "+") {
        setDynamicForm(false); // Close the modal
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [dynamicForm]);

  useEffect(() => {
    db.pricingRules.toArray().then((pr) => {
      const manualPricingRules = pr.filter((rule) => rule.manualDiscount === "Y");
      setManualDiscountTypes([...manualPricingRules]);
    });
  }, []);

  const clearCartData = {
    items: [],
    couponInput: [],
    advancePayment: 0,
    total: 0,
    tax: 0,
    discount: 0,
    paid: 0,
    change: 0,
    totalQty: 0,
    roundOff: 0,
    payments: [],
    redemptionPoints: 0,
    accumulationPoints: 0,
    creditAmount: 0,
    docType: "Invoice",
    sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
    referenceId: uuidv4().replace(/-/g, "").toUpperCase(),
    giftCardRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    couponRefId: uuidv4().replace(/-/g, "").toUpperCase(),
    customer: defaultCustomer,
    salesRepId: null,
    cardPaymentData: {},
    // documentno: cart.documentno,
    documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
    userName: userData.user,
    tillName: tillValue?.name,
    subTotal: 0,
    itemsSummery: {},
    amountInWords: "",
    groupedItemsByTaxRate: {},
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;

    setKeyboardInputFields({
      ...keyboardInputFields,
      [inputName]: inputVal,
    });

    keyboard?.current?.setInput(inputVal);
  };

  useEffect(() => {
    const fetchAndHandleSaleType = async () => {
      try {
        let selectedSaleTypeArray;
        if (keyValue === "0") {
          if (posConfig?.enableDineIn === "Y") {
            selectedSaleTypeArray = await getSaleTypeArray("DI");
            setSaleType("DI");
            localStorage.setItem("dineIn", "Y");
          } else if (posConfig?.enableTakeAway === "Y" && posConfig?.enableDineIn === "N") {
            selectedSaleTypeArray = await getSaleTypeArray("TA");
            setSaleType("TA");
          } else {
            setSaleType("HD");
          }
        }
        if (selectedSaleTypeArray) {
          handleSelectedSaleTypeForProducts(selectedSaleTypeArray)();
        }
      } catch (error) {
        console.error("Error fetching or handling sale type:", error);
      }
    };

    fetchAndHandleSaleType();
  }, []);

  useEffect(() => {
    if (keyValue === "0" && posConfig?.enableTakeAway === "Y") {
      localStorage.setItem("dineIn", "N");
    }
  }, [keyValue]);

  const getSaleTypeArray = async (type) => {
    try {
      const saleTypes = await db.posSaletypes.toArray();
      const selectedSaleTypeArray = saleTypes.filter((saleType) => saleType.cwrSaletype.value === type);
      return selectedSaleTypeArray.length > 0 ? selectedSaleTypeArray[0] : null;
    } catch (error) {
      console.error("Error fetching sale types:", error);
      return [];
    }
  };

  const formattedDateTime = `${currentDateTime.toLocaleTimeString()} | ${currentDateTime.toLocaleDateString("en-US", {
    weekday: "long", // Full day name (e.g., Wednesday)
    day: "numeric", // Day of the month (e.g., 28)
    month: "long", // Full month name (e.g., June)
    year: "numeric", // Full year (e.g., 2023)
  })}`;

  let cleanToken;
  const authHeaders = getOAuthHeaders();
  if (authHeaders) {
    cleanToken = authHeaders.access_token;
  }

  const handleKeyvalue = (value) => {
    setKeyValue(value);
    if (value === "0") {
      // history.push("/table-management");
    } else if (value === "2") {
      // let newCart = createNewCart(tillData);
      // setCart(newCart);
      localStorage.setItem("homeDelivery", "N");
    }
    localStorage.setItem("dineIn", "Y");

    if (value !== "2") {
      localStorage.setItem("homeDelivery", "Y");
    }
  };

  useEffect(async () => {
    await db.products
      .filter((product) => product.isactive === true)
      .toArray()
      .then((productsFetched) => {
        setProductsList([...productsFetched.slice(0, 50)]);
      });
    return () => {
      // socket.off("orderReceived", handleOrderReceived);
    };
  }, []);

  const getCustomerData = async (values) => {
    setGuestsModalFlag(false);
    setNumberOfPersons("");
    localStorage.setItem("dineIn", "Y");
    let tabledata = [];
    await db.tableData.toArray().then((fetched) => {
      fetched.map((item) => {
        if (item.cwrFbTableId === recordState.cwrFbTableId) {
          item.noOfPersons = values?.noOfGuests ?? 0;
          item.waiter = values?.waiter ?? "";
          item.referredBy = values?.referredBy === undefined ? "" : values?.referredBy;
          item.guestName = values?.guestName === undefined ? "" : values?.guestName;
          item.tableSync = "N";
          item.statusType = "OCU";
          item.fbtableStatusId = item.fbtableStatusId === undefined ? uuidv4().replace(/-/g, "").toUpperCase() : item.fbtableStatusId;
          item.guestType = priorityBtn ? "single" : "family";
          item.salesRepId = tillData.tillAccess.salesRepId;
          item.uniqueId = uuidv4().replace(/-/g, "").toUpperCase();
          item.color = "#bc4749";
          item.ordered = "N";
          item.items = [];
        }
        tabledata.push(item);
      });
    });
    await db.tableData.clear();
    await db.tableData.bulkPut(tabledata);
    localStorage.setItem("locatedList", JSON.stringify(tabledata));
    localStorage.setItem("tableName", JSON.stringify(recordState));
    setSelectedTable(recordState);
    setTableCards(tabledata);
    setMainTableData(tabledata);
    setOcupiedTablesData(tabledata.filter((table) => table.statusType === "OCU"));
    setShowProducts(true);
    if (posConfig?.enableGuestRegistration !== "Y") {
      handleDisplayOk(recordState);
    }
  };

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        if (!selectedTable) return;
        let newCart = cart;
        const tableData = await db.tableData.where("cwrFbTableId").equals(selectedTable?.cwrFbTableId).toArray();
        if (tableData.length > 0) {
          if ((tableData[0].ordered === "N" || !tableData[0].ordered) && tableData[0].statusType !== "OCU") {
            await handleNewOrder(tableData[0], newCart, userPreferences);
          } else {
            await handleExistingOrder(selectedTable);
          }
          await cleanupCompletedOrders();
        }
      } catch (error) {
        console.error("Error in useOrderManagement:", error);
      }
    };

    fetchTableData();
  }, [orderCanceled, selectedTable]);

  const handleNewOrder = async (tableData, newCart, userPreferences) => {
    let allTableData = await db.tableData.toArray();
    const updatedResponse = {
      ...tableData,
      fbOrderId: uuidv4().replace(/-/g, "").toUpperCase(),
      lines: [],
      statusType: "OCU",
      ordered: "Y",
      fbOrderSync: "N",
      fbOrderStatus: "IP",
      dineIn: localStorage.getItem("dineIn"),
      createdTime: moment(new Date()).format(userPreferences.dateTimeFormat),
      cart: newCart,
    };

    const updatedTableData = allTableData.map((item) => {
      if (item.cwrFbTableId === tableData.cwrFbTableId) {
        item.ordered = "Y";
        item.documentno = newCart.documentno;
        item.statusType = "OCU";
        item.color = "#a7c957";
      }
      return item;
    });
    await db.fbOrderData.add(updatedResponse);
    await db.tableData.clear();
    await db.tableData.bulkPut(updatedTableData);

    SyncData(updatedResponse, "upsertTableStatus");
    setCart(updatedResponse.cart || newCart);
  };

  const parseCreatedTime = (timeStr) => {
    // "29-09-2025 16:31:11"
    const [datePart, timePart] = timeStr.split(" ");
    const [day, month, year] = datePart.split("-");
    return new Date(`${year}-${month}-${day}T${timePart}`);
  };

  const handleExistingOrder = async (selectedTable) => {
    // const orders = await db.fbOrderData.where("cwrFbTableId").equals(selectedTable?.cwrFbTableId).toArray();
    // const ordersFetched = orders.sort((a, b) => parseCreatedTime(b.createdTime) - parseCreatedTime(a.createdTime));
    // if (ordersFetched.length > 0) {
    //   ordersFetched.forEach((fbOrder) => {
    //     if (fbOrder.fbOrderStatus === "IP") {
    //       let cartData = {
    //         ...fbOrder.cart,
    //         discount: fbOrder.cart.discount || 0,
    //         orderTime: fbOrder.creatdeTime,
    //         tableNo: fbOrder.name,
    //         statusType: "OCU",
    //         sOrderID: fbOrder?.cart?.sOrderID || uuidv4().replace(/-/g, "").toUpperCase(),
    //         items: fbOrder.cart.items.map((item) => ({
    //           ...item,
    //           sendQty: 0,
    //         })),
    //       };
    //       setCart(cartData);
    //       localStorage.setItem("cartObj", JSON.stringify(cartData));
    //     }
    //   });
    // }
    const response = await SyncData(selectedTable, "getFBOrder", setLoading, "IP");
    if (!response || response.length === 0) {
      setLoading(false);
      message.success("No in-progress order exists for this table.");

      return;
    }
    localStorage.setItem("getFBOrderData", JSON.stringify(response));
    const order = response[0];
    let cartFromMeta = {};
    if (Array.isArray(order?.meta) && order.meta.length > 0) {
      const firstMeta = order?.meta[0];
      if (firstMeta?.key === "cartDetails") {
        cartFromMeta = JSON.parse(firstMeta?.value);
      }
    }

    let items = [];
    if (order?.lines && Array.isArray(order.lines)) {
      items = order.lines.map((line) => {
        const orderLineMeta = Array.isArray(line.meta) ? line.meta.find((m) => m.key === "orderLine") : null;

        const orderLineData = orderLineMeta ? JSON.parse(orderLineMeta.value) : {};

        const lineData = {
          csTaxId: line.csTaxId,
          tax: line.csTaxId,
          uom: line.csUomId,
          csUomId: line.csUomId,
          description: line.description,
          discount: line.discount,
          fbOrderLineId: line.fbOrderLineId,
          isCanceled: line.isCanceled,
          isOrdered: line.isOrdered,
          line: line.line,
          listPrice: line.listPrice,
          mBatchId: line.mBatchId,
          mProductId: line.mPoductId,
          mPricingRuleId: line.mPricingRuleId,
          name: line.name,
          netList: line.netList,
          netStd: line.netStd,
          sOrderLineId: line.sOrderLineId,
          unitPrice: line.unitPrice,
          unitTax: line.unitTax,
          value: line.value,
          grossstd: line.grossStd,
          grossunit: line.grossUnit,
          linegross: line.lineGross,
          linestd: line.lineStd,
          linetax: line.lineTax,
          netunit: line.netUnit,
          weight: line.qty,
          fbOrderLineId: line.fbOrderLineId,
          sendQty: 0,
          linenet: line?.lineNet,
        };

        return {
          ...lineData,
          ...orderLineData,
        };
      });
    }

    const finalCart = {
      ...cartFromMeta,
      items,
    };
    setCart(finalCart);
    localStorage.setItem("cartObj", JSON.stringify(finalCart));
  };

  const cleanupCompletedOrders = async () => {
    await db.fbOrderData
      .where("fbOrderStatus")
      .equals("CO")
      .and((order) => order.fbOrderSync === "Y")
      .delete();
  };

  const [displayAddOnSelection, setDisplayAddOnSelection] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [addOnsList, setAddOnsList] = useState({
    requiredList: [],
    optionsList: [],
  });
  const [selectedAddons, setSelectedAddons] = useState([]);

  const handleAddOnModal = (record, event) => {
    event.stopPropagation();
    setDisplayAddOnSelection(true);
    setSelectedProduct(record);
    const requiredListFilter = _.filter([...record.productAddons], (item) => item.mAddonGroup.minqty === 1);
    const optionsListFilter = _.filter([...record.productAddons], (item) => item.mAddonGroup.minqty === 0);
    setAddOnsList({
      requiredList: requiredListFilter || [],
      optionsList: optionsListFilter || [],
    });
  };

  const handleAddOnValue = (e, fieldName) => {
    let newSelectedAddons = [...selectedAddons];
    const indexValue =
      fieldName === "addOnRadio"
        ? _.findIndex(newSelectedAddons, (item) => item.mAddonGroup.mAddonGroupId === e.target.value.mAddonGroup.mAddonGroupId)
        : _.findIndex(newSelectedAddons, (item) => item === e.target.value);
    if (indexValue !== -1) {
      if (e.target.checked) {
        newSelectedAddons[indexValue] = e.target.value;
      } else {
        newSelectedAddons.splice(indexValue, 1);
      }
    } else {
      newSelectedAddons = [...selectedAddons, e.target.value];
    }
    setSelectedAddons(newSelectedAddons);
  };

  const handleQty = (fieldName) => {
    let newSelectedProduct = {
      ...selectedProduct,
      weight: selectedProduct?.weight || 1,
    };
    if (fieldName === "plus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) + 1;
    }
    if (fieldName === "minus") {
      newSelectedProduct.weight = Number(newSelectedProduct.weight) - 1;
      if (newSelectedProduct.weight <= 1) {
        newSelectedProduct.weight = 1;
      }
    }

    setSelectedProduct({
      ...newSelectedProduct,
    });
  };

  const handleAdd = async () => {
    await addDefinedProductWithAddons(
      {
        ...selectedProduct,
        sProductID: uuidv4().replace(/-/g, "").toUpperCase(),
        productAddons: selectedAddons || [],
      },
      selectedProduct.upc,
      null,
      null,
      selectedProduct.sunitprice
    );
    handleAddOnModalClose();
  };

  const handleAddOnModalClose = () => {
    setDisplayAddOnSelection(false);
    setSelectedAddons([]);
  };
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const manualDiscountRestaurant = async (values) => {
    if (selectedProductInCart) {
      const pr = await db.pricingRules.toArray();
      const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
      if (index !== -1) {
        const pricingRule = pr[index];
        if (pricingRule.type !== "TD") {
          let discountValue =
            pricingRule.discountType === "V"
              ? selectedProductInCart.discount
              : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(2);
          manualDiscountForm.setFieldsValue({
            discountName: pricingRule.mPricingrulesId,
            discountValue: discountValue,
          });
          setManualDiscountInput(discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        } else {
          const matchedPricingRule = cart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
          manualDiscountForm.setFieldsValue({
            discountName: pricingRule.mPricingrulesId,
            discountValue: cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
          });
          setManualDiscountInput(cart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
          setSelectedManualDiscountTypeValue(pricingRule);
        }
      } else {
        manualDiscountForm.resetFields();
        setManualDiscountInput("");
        setSelectedManualDiscountTypeValue("");
      }
    }
    parseInt(cart.total) > 0 && setManualDiscountModalVisible(true);
  };

  const handleCancelOrder = async () => {
    await db.tableData
      .where("cwrFbTableId")
      .equals(selectedTable.cwrFbTableId)
      .toArray()
      .then(async (response) => {
        if (response.length > 0) {
          response[0].status = "OPN";
          response[0].salesRepId = response[0].waiter;
          response[0].lines = [];
          response[0].color = "rgba(146, 144, 152, 0.5)";
          response[0].statusType = "OPN";
          response[0].fbOrderSync = "N";
          response[0].tableSync = "N";
          await db.tableData.update(response[0].cwrFbTableId, response[0]);
          SyncData(response[0], "upsertTableStatus");
          await db.fbOrderData
            .where("cwrFbTableId")
            .equals(selectedTable?.cwrFbTableId)
            .toArray()
            .then((ordersFetched) => {
              if (ordersFetched.length > 0) {
                ordersFetched.map(async (fbOrder) => {
                  if (fbOrder.fbOrderStatus === "IP") {
                    db.fbOrderData.where("fbOrderId").equals(fbOrder.fbOrderId).modify({ fbOrderSync: "N", fbOrderStatus: "CL" });
                    SyncData(fbOrder, "upsertFbOrder");
                  }
                });
              }
            });
          // history.push("/table-management");
          history.push("/pos");
        }
      });
  };

  const handleOrder = () => {
    let newLocated = [...locatedList];
    let newCart = cart;
    // newCart?.items?.map((cartItem, index) => (cartItem.parkedItem = true));
    if (selectedProducts.length > 0) {
      newCart.items = newCart.items.map((cartItem) => {
        const existsInSelected = selectedProducts?.find((product) => product && product.productId === cartItem?.productId);

        if (existsInSelected && cartItem.order === "Y") {
          return {
            ...cartItem,
            order: "N",
          };
        }
        return cartItem;
      });
    }
    let newTempData = newCart?.items?.filter((cartItem, index) => cartItem.order === "N");
    const index = locatedList?.findIndex((item) => item.cwrFbTableId === selectedTable?.cwrFbTableId);
    let serviceData = {};
    if (index !== -1) {
      newLocated[index] = {
        ...newLocated[index],
        cart: newCart,
      };
      serviceData = newLocated[index];
    } else {
      let object = {
        name: selectedTable?.table,
        cart: newCart,
        noOfPersons: selectedTable?.noOfPersons,
        dineIn: localStorage.getItem("dineIn"),
      };
      newLocated = [...newLocated, object];
      serviceData = object;
    }
    setLocatedList([...newLocated]);
    if (newCart.totalQty > 0 && newTempData.length > 0) {
      setOederedData(newTempData);
      setSelectedItemsModalOpen(true);
    }
    setSelectedproducts([]);
  };

  const handleDisplayOk = async (recordState) => {
    let orderId = localStorage.getItem("orderId") === null ? 1 : Number(localStorage.getItem("orderId")) + 1;
    // setLoading(true);
    localStorage.setItem("orderId", orderId);
    setSelectedItemsModalOpen(false);
    setShowSendToKitchen(false);
    let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
    let tableInfo = JSON.parse(localStorage.getItem("tableName"));
    if (recordState) {
      recordState.uniqId = uniqId;
    }
    // localStorage.removeItem("tableName");
    localStorage.setItem("tableName", JSON.stringify(recordState));
    let newCart = {
      ...cart,
      tableNo: recordState?.table,
    };
    newCart?.items?.map((cartItem, index) => (cartItem.parkedItem = true));
    let orderLines = [];
    if (recordState?.cwrFbTableId) {
      const existingFbOrder = await db.fbOrderData.where("cwrFbTableId").equals(recordState.cwrFbTableId).first();
      let fbOrder;
      let fbOrderId;
      if (existingFbOrder) {
        fbOrder = existingFbOrder;
        fbOrderId = existingFbOrder.fbOrderId;
      } else {
        const fbOrders = JSON.parse(localStorage.getItem("getFBOrderData") || "[]");
        const filteredOrders = Array.isArray(fbOrders) ? fbOrders.filter((o) => o.fbTableId === recordState?.cwrFbTableId || o.fbTableId === recordState?.fbTableId) : [];
        const fbOrderDataID = filteredOrders[0]?.fbOrderId;
        fbOrderId = fbOrderDataID || uuidv4().replace(/-/g, "").toUpperCase();
        fbOrder = {
          fbOrderId,
          cwrFbTableId: recordState?.cwrFbTableId,
          fbOrderStatus: "IP",
          lines: [],
          fbOrderSync: "N",
          cart: newCart,
          name: recordState?.table,
          noOfPersons: recordState?.noOfPersons,
          statusType: "OCU",
          dineIn: localStorage.getItem("dineIn"),
          uniqId: uniqId,
        };
      }

      const orderLines = [];
      orderedData.forEach((item) => {
        const fbOrderLineId = item?.fbOrderLineId || uuidv4().replace(/-/g, "").toUpperCase(); // ✅ reuse if exists
        const fbMetaOrderId = item?.fbMetaOrderId || uuidv4().replace(/-/g, "").toUpperCase(); // reuse meta id if you store it

        const usedKeysLower = new Set([
          "productid",
          "mbatchid",
          "description",
          "uom",
          "tax",
          "discount",
          "weight",
          "unitprice",
          "listprice",
          "linegross",
          "lineid",
          "grossstd",
          "name",
          "value",
          "grossunit",
          "linestd",
          "netlist",
          "netstd",
          "netunit",
          "unittax",
          "order",
        ]);

        const metaFromItem = Object.fromEntries(Object.entries(item).filter(([key]) => !usedKeysLower.has(key.toLowerCase())));
        const metaString = {
          ...metaFromItem,
          fbMetaOrderId,
          fbOrderLineId,
          isSelected: "N",
          order: "Y",
        };

        item.fbOrderLineId = fbOrderLineId;

        orderLines.push(`{
      fbOrderId: "${fbOrderId}"
      fbOrderLineId: "${fbOrderLineId}"
      mPoductId: "${item.productId || item.mPoductId}"
      mBatchId: ${item.mBatchId}
      description: "${item.description}"
      csUomId: "${item.uom}"
      csTaxId: "${item.tax}"
      discount:${item.discount}
      line: 1
      qty: ${item.weight}
      unitPrice: ${item.unitPrice}
      listPrice: ${item.listPrice}
      lineNet: ${item.linenet}
      lineTax: ${item.taxRate}
      lineGross: ${item.linegross}
      sOrderLineId: null
      isOrdered: "Y"
      isCanceled: "N"
      grossStd: ${item.grossstd}
      grossUnit: ${item.grossunit}
      lineStd: ${item.linestd}
      netList: ${item.netList}
      netStd: ${item.netStd}
      netUnit: ${item.netunit}
      unitTax: ${item.unitTax}
      meta:[{
        key:"orderLine"
        value:${JSON.stringify(JSON.stringify(metaString))}
        fbOrderLineMetaId:"${fbMetaOrderId}"
      }]
    }`);
      });

      // 🧺 KOT printing and cart flags
      const array1 = {};
      for (const item of newCart.items || []) {
        const printer = item.productionCenter;
        if (!array1[printer]) array1[printer] = [];
        array1[printer].push(item);
      }

      setCart(newCart);

      if (posConfig?.enableKOTPrint === "Y") {
        if (CWHardwareController) {
          const filteredCart = {
            ...newCart,
            items: (newCart.items || []).filter((item) => item?.order !== "Y"),
          };
          CWKOTPrinter(filteredCart);
        } else {
          kotPrinter(array1, fbOrderId);
        }
      }

      newCart?.items?.forEach((cartItem) => {
        cartItem.order = "Y";
        cartItem.update = "N";
      });

      // fbOrder.lines = [...(fbOrder.lines || []), ...orderLines];
      fbOrder.lines = orderLines;
      fbOrder.fbOrderSync = "N";
      fbOrder.cart = newCart;
      fbOrder.documentno = newCart.documentno;
      await db.fbOrderData.put(fbOrder, fbOrderId);
      await SyncData(fbOrder, "upsertFbOrder", setLoading, "", true);

      const updatedTableData = await db.tableData.toArray();
      setTableCards(updatedTableData);
      const ocuTables = updatedTableData.filter((table) => table.statusType === "OCU");
      setOcupiedTablesData(ocuTables);
      const resTables = updatedTableData.filter((table) => table.statusType === "RES");
      setReservedTablesData(resTables);
      const tempData = [];
      await db.tableData.toArray().then((fetched) => tempData.push(...fetched));
      setTableList(tempData);

      const tableOccupied = newCart?.statusType === "OCU";
      if (!tableOccupied) {
        const newDocumentSequence = documentSequence + 1;
        localStorage.setItem("documentSequence", newDocumentSequence);
        setDocumnetSequence(newDocumentSequence);
      }
    }
    setKeyValue("0");
    setShowProducts(false);
  };

  // Kitchen Display Modal Starts //

  const orderStatus = [
    {
      title: "All",
      imgSrc: All,
      statusValue: "NE",
    },
    {
      title: "Parked",
      imgSrc: ParkedOrder,
      statusValue: "NE",
    },
    {
      title: "Pending",
      imgSrc: Pending,
      statusValue: "NE",
    },
    {
      title: "In Progress",
      imgSrc: InProgress,
      statusValue: "UP",
    },
    {
      title: "Prepared",
      imgSrc: Prepared,
      statusValue: "PR",
    },
    {
      title: "Completed",
      imgSrc: Completed,
      statusValue: "DE",
    },
  ];

  const [displayOrderItemsModal, setDisplayOrderItemsModal] = useState(false);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState(orderStatus[0]);

  const orderDetailsList = JSON.parse(localStorage.getItem("orderDetails"));
  const initialOrderList = orderDetailsList ? orderDetailsList : [];
  const [orderDetails, setOrderDetails] = useState(initialOrderList);

  const handleOrderStatus = async () => {
    db.orders
      .orderBy("orderTime")
      .limit(20)
      .reverse()
      .toArray()
      .then((data) => {
        if (data?.length > 0) {
          data?.map((item) => {
            let time = new Date(item.orderTime);
            let newTime = time.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true,
            });
            let newLineItems = item?.items?.map((itemLine) => ({
              ...itemLine,
              price: itemLine?.salesPrice || 0,
              quantity: itemLine?.weight || 0,
            }));
            let orderObj = {
              cWCOrderId: item.sOrderID || "",
              customerId: item?.customer?.cwrCustomerId || "",
              customerName: item?.customer?.name || "",
              lineItems: [...newLineItems],
              mobileNo: item?.customer?.mobileNo,
              noOfItems: item?.items?.length,
              orderNo: item.documentno,
              posOrders: "Y",
              status: "NE",
              total: item?.total || 0,
              totalQty: item?.totalQty || 0,
              dateCreated: newTime,
            };
            let findIndexOrder = _.findIndex(orderDetails, ["cWCOrderId", orderObj.cWCOrderId]);
            if (findIndexOrder === -1) {
              orderDetails.push(orderObj);
            } else {
              orderDetails[findIndexOrder] = orderObj;
            }
            return null;
          });
        }
      });
    const paramsInput = {
      query: `query{
        getNewOmsOrders(bunitId:"${tillData.tillAccess.csBunit.csBunitId}"){
        cWCOrderId
        orderNo
        dateCreated
        customerId
        customerName
        mobileNo
        total
        noOfItems
        totalQty
        lineItems{
            productId
            name
            productCode
            quantity
            price
            subTotal
            addOnProducts{
                id
                name
                price
            }
        }
    }
    }`,
    };
    try {
      const response = await getNewOmsOrder(paramsInput);
      const { getNewOmsOrders } = response.data.data;
      getNewOmsOrders?.map((item, index) => {
        let obj = { ...item };
        obj.status = "NE";
        obj.noOfItems = item.lineItems.length;
        obj.posOrders = "N";
        let time = new Date(item.dateCreated);
        let newTime = time.toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
        obj.dateCreated = newTime;
        let findIndex = _.findIndex(orderDetails, ["cWCOrderId", item.cWCOrderId]);
        if (findIndex === -1) {
          orderDetails.push(obj);
        } else {
          orderDetails[findIndex] = obj;
        }
        return null;
      });
      localStorage.setItem("orderDetails", JSON.stringify([...orderDetails]));
      setOrderDetails([...orderDetails]);
    } catch (err) {
      console.log(err);
    }
    setDisplayOrderItemsModal(true);
  };

  const handleOrderStatusSelection = (record) => {
    setSelectedOrderStatus(record);
  };

  const nextOrderStatus = () => {
    let newOrderStatus = [...orderStatus];
    let statusIndex = _.findIndex(newOrderStatus, (item) => item.title === selectedOrderStatus.title);
    if (statusIndex <= newOrderStatus.length - 1) setSelectedOrderStatus(newOrderStatus[statusIndex + 1]);
  };

  const setStatus = (status) => {
    let newStatus = "";
    switch (status) {
      case "NE":
        newStatus = "UP";
        break;
      case "UP":
        newStatus = "PR";
        break;
      case "PR":
        newStatus = "DE";
        break;
      default:
        newStatus = "NE";
    }
    return newStatus;
  };

  const handleStatusButton = (record) => {
    if ((record.status === "NE" || record.status === "UP" || record.status === "PR") && record.posOrders === "N") {
      handleInProgress(record);
    } else {
      let newOrderDetails = [...orderDetails];
      let recordIndex = _.findIndex(newOrderDetails, ["cWCOrderId", record.cWCOrderId]);
      newOrderDetails[recordIndex].status = setStatus(record.status);
      localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
      setOrderDetails([...newOrderDetails]);
      nextOrderStatus();
    }
  };

  const handleInProgress = async (record) => {
    const paramsInput = {
      query: `mutation{
        updateOMSOrderStatus(order:{
            cWCOrderId: "${record.cWCOrderId}"
            status: "${record.status}"
        })
        {
            status
            message
        }
    }`,
    };
    try {
      const response = await updateOMSOrderStatus(paramsInput);
      if (response?.data?.data?.updateOMSOrderStatus?.status === "200") {
        let newOrderDetails = [...orderDetails];
        let recordIndex = _.findIndex(newOrderDetails, ["cWCOrderId", record.cWCOrderId]);
        newOrderDetails[recordIndex].status = setStatus(record.status);
        localStorage.setItem("orderDetails", JSON.stringify(orderDetails));
        setOrderDetails([...newOrderDetails]);
        nextOrderStatus();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const [barcodeOrderList, setBarcodeOrderList] = useState([]);
  const [barcodeOrderStatusModal, setBarcodeOrderStatusModal] = useState(false);

  const handleAccept = async (record) => {
    const paramsInput = {
      query: `mutation{
        updateOMSOrderStatus(order:{
            cWCOrderId: "${record.cWCOrderId}"
            status: "DE"
        })
        {
            status
            message
        }
    }`,
    };
    try {
      const response = await updateOMSOrderStatus(paramsInput);
      if (response?.data?.data?.updateOMSOrderStatus?.status === "200") {
        message.success(`Order ${barcodeOrderList[0]?.orderNo} ${messages.errors.cart.completed_successfully}`);
        setBarcodeOrderStatusModal(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleBarcodeOrderPrint = (printedData) => {
    const printWindow = window.open("", "printWindow", "width=0,height=0");
    let printedDataArray = printedData?.lineItems?.map((item) => ({
      ...item,
      productName: item?.name,
      price: item?.price,
      qty: item?.quantity,
    }));
    const barcodeOrderData = `
      <html>
      <style>
      th,td {
        padding: 15px;
      }
      </style>
        <div style="width:100%;">
        <div style="text-align:center; margin-bottom: 20px;"><h4>${tillData.tillAccess.csBunit.name}</h4></div>
        <div style="display:flex; margin-bottom: 20px;">
        <span>Order No</span>
          <span style="margin-left: 100px;">${printedData.orderNo}</span>
        </div>
        <div style="display:flex; margin-bottom: 20px;">
        <span>Date</span>
          <span style="margin-left: 100px;">${printedData.dateCreated}</span>
        </div>
        <hr />
        <table style="width:100%">
              <tr>
                <th style="text-align:left;"><strong>Product</strong></th>
                <th style="text-align:left;"><strong>Qty</strong></th>
                <th style="text-align:left;"><strong>Price</strong></th>
              </tr>
              ${printedDataArray?.map((item) => {
                return `<tr>
                  <td>${item.productName}</td>
                  <td>${item.qty}</td>
                  <td>${item.price}</td>
                </tr>
                ${item?.addOnProducts?.map((addonItem) => {
                  return `<tr>
                    <td>--${addonItem.name}</td>
                    </tr>`;
                })}
               `;
              })}
          </table>
          <div style="display:flex; margin-top: 30px;">
          <h2>Total</h2>
            <h2 style="margin-left: 100px; text-align: end">${_.sumBy(printedDataArray, "price")}</h2>
          </div>
          <div style="text-align:center; margin-bottom: 20px;"><h4>Thank You</h4></div>
        </div>
      </html>`;
    printWindow.document.write(barcodeOrderData);
    printWindow.print();
    printWindow.close();
  };
  const [billConfirmationModalOpen, setBillConfirmationModalOpen] = useState(false);
  const [notesModalOpen, setNotesModalOpen] = useState(false);
  const [layout, setLayout] = useState("default");
  const [inputs, setInputs] = useState({});
  const [inputName, setInputName] = useState("");
  const [categorieFlag, setCategorieFlag] = useState(false);
  const keyboard = useRef(null);
  const prevCustomerIdRef = useRef(null);

  const handleShift = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
  };

  const handleNotesValue = (event) => {
    const inputVal = event.target.value;
    setInputs({
      ...inputs,
      [inputName]: inputVal,
    });
    keyboard.current.setInput(inputVal);
  };

  const clearCart1 = async (type) => {
    const tillSession = JSON.parse(localStorage.getItem("tillSession"));
    const tillSessionId = tillSession.tillSessionId;
    const newDocumentSequence = cart.parked === "Y" || cart.statusType === "OCU" ? documentSequence : documentSequence + 1;
    let cartToDb = cart;
    cartToDb.orderTime = timeStamp();
    cartToDb.createdBy = tillData.tillAccess.csUserId;
    cartToDb.orderType = orderType?.cwrSaletype?.cwrSaletypeId;
    cartToDb.orderDate = moment(new Date()).format("YYYY-MM-DD");
    cartToDb.tillSessionId = tillSessionId;
    cartToDb.key = uuidv4().replace(/-/g, "").toUpperCase();
    cartToDb.isSynced = 0;
    cartToDb.syncAttempts = 0;
    cartToDb.customerSearchKey = cart.customer.code;
    cartToDb.tax = 0;
    cartToDb.total = 0;
    cartToDb.docType = "Invoice";
    cartToDb.totalQty = 0;
    cartToDb.couponInput = [];
    cartToDb.discount = 0;
    cartToDb.isReturn = false;
    cartToDb.items.forEach((item) => {
      item.salePrice = 0;
      item.sunitprice = 0;
      item.netStd = 0;
      item.nettotal = 0;
      item.unitTax = 0;
      item.taxAmount = 0;
      item.weight = 0;
      item.unitPrice = 0;
      item.isReturn = false;
      item.netList = 0;
      item.discount = 0;
      item.linetax = 0;
      item.linenet = 0;
      item.linegross = 0;
      item.linestd = 0;
      item.netunit = 0;
      item.listPrice = 0;
      item.grossunit = 0;
      item.grossstd = 0;
      item.grosslist = 0;
    });
    deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
    setGiftCardData([]);
    if (type === "Layaway") {
      setDocumnetSequence(documentSequence);
    } else {
      localStorage.setItem("documentSequence", newDocumentSequence);
      setDocumnetSequence(newDocumentSequence);
      await db.orders.add(cartToDb);
    }
  };

  const handleVoid = async (record) => {
    Modal.confirm({
      title: "This action will cancel the ordered items. Do you wish to proceed?",
      cancelText: "No",
      okText: "Yes",
      onOk: async () => {
        const { workflowRules, approvers } = await getWorkflowData();
        const cancelKotRule = workflowRules.find((res) => res.eventName === "Cancel KOT");
        if (cancelKotRule) {
          dispatchEvent(cancelKotRule.eventName, cancelKotRule.ruleName, cancelKotRule.ruleCondition, approvers, async (eventData) => {
            if (eventData?.approvalGranted) {
              await proceedWithCancellation(record);
            } else {
              Modal.error({
                title: "Approval Required",
                content: "The cancellation request was not approved.",
              });
            }
          });
        } else {
          await proceedWithCancellation(record);
        }
      },
    });

    async function proceedWithCancellation(record) {
      const dineInKey = localStorage.getItem("dineIn");
      if (dineInKey && dineInKey === "Y") {
        // await db.fbOrderData
        //   .where("cwrFbTableId")
        //   .equals(record?.cwrFbTableId)
        //   .toArray()
        //   .then(async (ordersFetched) => {
        await handleExistingOrder(record);
        let ordersFetched = await db.fbOrderData.where("cwrFbTableId").equals(record?.cwrFbTableId).toArray();
        if (ordersFetched.length > 0) {
          for (const fbOrder of ordersFetched) {
            if (fbOrder.fbOrderStatus === "IP") {
              fbOrder.fbOrderStatus = "CL";
              fbOrder.fbOrderSync = "N";
              await db.fbOrderData.where("fbOrderId").equals(fbOrder.fbOrderId).modify({
                fbOrderSync: "N",
                fbOrderStatus: "CL",
              });
              await SyncData(fbOrder, "upsertFbOrder");

              await db.tableData
                .where("cwrFbTableId")
                .equals(record?.cwrFbTableId)
                .toArray()
                .then(async (response) => {
                  if (response.length > 0) {
                    let tableData = { ...response[0] };
                    tableData.statusType = "OPN";
                    tableData.color = "rgba(146, 144, 152, 0.5)";
                    await SyncData(tableData, "upsertTableStatus");
                    await db.tableData.update(tableData.cwrFbTableId, {
                      color: "rgba(146, 144, 152, 0.5)",
                      noOfPersons: "",
                      guestName: "",
                      guestType: "",
                      referredBy: "",
                      statusType: "OPN",
                      items: [],
                      ordered: "N",
                    });

                    setTableCards((prevTableCards) => prevTableCards.map((card) => (card.cwrFbTableId === tableData.cwrFbTableId ? { ...card, ...tableData } : card)));

                    const updatedTableData = await db.tableData.toArray();
                    setOcupiedTablesData(updatedTableData.filter((table) => table.statusType === "OCU"));
                    setReservedTablesData(updatedTableData.filter((table) => table.statusType === "RES"));
                    // clearCart(cart.type);
                    setCart(clearCartData);
                    localStorage.setItem("cartObj", JSON.stringify(clearCartData));
                    setTableCards(updatedTableData);
                    setMainTableData(updatedTableData);
                  }
                });

              history.push("/pos");
              setKeyValue("0");
              setShowProducts(false);
            }
          }
        } else if (ordersFetched.length === 0 || !ordersFetched) {
          const fbOrderData = JSON.parse(localStorage.getItem("getFBOrderData"));
          for (const fbOrder of fbOrderData) {
            if (fbOrder.status === "IP" || fbOrder.fbOrderStatus === "IP") {
              fbOrder.fbOrderStatus = "CL";
              fbOrder.fbOrderSync = "N";
              fbOrder.tableSync = "N";
              fbOrder.statusType = "N";
              if (Array.isArray(fbOrder.lines)) {
                fbOrder.lines = fbOrder.lines.map(({ name, value, ...rest }) => ({
                  ...rest,
                }));
              }
              await db.fbOrderData.put(fbOrder, fbOrder.fbOrderId);
              // await db.fbOrderData.where("fbOrderId").equals(fbOrder.fbOrderId).modify({
              //   fbOrderSync: "N",
              //   fbOrderStatus: "CL",
              // });

              await SyncData(fbOrder, "upsertFbOrder");

              await db.tableData
                .where("cwrFbTableId")
                .equals(record?.cwrFbTableId)
                .toArray()
                .then(async (response) => {
                  if (response.length > 0) {
                    let tableData = { ...response[0] };
                    tableData.statusType = "OPN";
                    tableData.color = "rgba(146, 144, 152, 0.5)";
                    await SyncData(tableData, "upsertTableStatus");
                    await db.tableData.update(tableData.cwrFbTableId, {
                      color: "rgba(146, 144, 152, 0.5)",
                      noOfPersons: "",
                      guestName: "",
                      guestType: "",
                      referredBy: "",
                      statusType: "OPN",
                      items: [],
                      ordered: "N",
                    });

                    setTableCards((prevTableCards) => prevTableCards.map((card) => (card.cwrFbTableId === tableData.cwrFbTableId ? { ...card, ...tableData } : card)));

                    const updatedTableData = await db.tableData.toArray();
                    setOcupiedTablesData(updatedTableData.filter((table) => table.statusType === "OCU"));
                    setReservedTablesData(updatedTableData.filter((table) => table.statusType === "RES"));
                    // clearCart(cart.type);
                    setCart(clearCartData);
                    localStorage.setItem("cartObj", JSON.stringify(clearCartData));
                    setTableCards(updatedTableData);
                    setMainTableData(updatedTableData);
                  }
                });

              history.push("/pos");
              setKeyValue("0");
              setShowProducts(false);
            }
          }
        }
        // });
        clearCart1(cart.type);
      } else {
        setCategorieFlag(false);
        clearCart1(cart.type);
        // deleteCart(true, cart.parked === "Y" ? "parked" : cartToDb.type);
      }
    }
  };

  const tillUnlink = async () => {
    let parkedBills = JSON.parse(localStorage.getItem("parkedList"));
    let posConfig = JSON.parse(localStorage.getItem("posConfig"));
    const orders = await db.orders.where("isSynced").equals(0).toArray();
    if (parkedBills?.length > 0) {
      {
        message.error(`${t("unlink_till_parked_bill_error")}`);
      }
    } else if (cart?.items?.length > 0) {
      {
        message.error(`${t("unlink_till_cart_error")}`);
      }
    } else if (orders?.length > 0) {
      message.error(`${messages.errors.till_management.unlink_till_sync_po}`);
    } else {
      // If none of the conditions is satisfied, you can provide a default message
      if (posConfig?.shiftClose === "Y") {
        if (posConfig?.showDenominations === "Y") {
          history.push("/close-till");
          localStorage.setItem("unlink", true);
        } else if (posConfig?.showDenominations === "N") {
          history.push("/close-till-all");
          localStorage.setItem("unlink", true);
        }
      } else {
        history.push("/");
      }
    }
  };

  const [isUnlinkTillClicked, setIsUnlinkTillClicked] = useState(false);

  const handleUnlinkTillClick = () => {
    if (cart.paid > 0) {
      message.warning(`${messages.errors.till_management.delete_payment_method}`);
      return;
    }
    if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
      message.warning(`${messages.errors.cart.cart_switch_section}`);
      return;
    }
    if (showSendToKitchen) {
      message.warning(`${messages.errors.cart.cart_switch_section}`);
      return;
    }
    if (splitBillScreen) {
      message.warning(messages.errors.cart.cart_switch_section);
      return; // stop navigation
    }
    setIsUnlinkTillClicked(true);
    tillUnlink();
  };

  useEffect(() => {
    if (keyValue === "0" && accessController?.dineIn === "N") {
      setKeyValue("2");
    }
  }, []);

  const restaurantProductCategory = async (categorie) => {
    const filteredProducts = saleTypeProducts.filter((product) => product.mProductCategoryId === categorie);
    setProductsData(filteredProducts);
  };

  const antIcon = <LoadingOutlined style={{ fontSize: "24px" }} spin />;
  const tableLayoutProps = {
    orderFlags,
    setOrderFlags,
    setFiltersFlag,
    guestsModalFlag,
    setGuestsModalFlag,
    noOfPersons,
    setNumberOfPersons,
    priorityBtn,
    setPriorityBtn,
    getCustomerData,
    selectedProducts,
    setSelectedproducts,
    removeSplit,
    setRemoveSplit,
    clearCart,
    isSplitBill,
    setIsSplitBill,
    currentSplitIndex,
    setCurrentSplitIndex,
    splitCarts,
    setSplitCarts,
    showAllItems,
    setShowAllItems,
    numSplits,
    setNumSplits,
    splitBillScreen,
    setSplitBillScreen,
    showSplitBill,
    setShowSplitBill,
    tableList,
    setTableList,
    saleType,
    setSaleType,
    handleAmount,
    handleCashPayment,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    requestPayment,
    amount,
    setAmount,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    posConfig,
    setSelectedProductInCart,
    selectedProductId,
    setSelectedProductId,
    manualDiscountRestaurant,
    filteredPaymentMethods,
    getFilteredPaymentMethods,
    keyValue,
    setKeyValue,
    cart,
    setCart,
    showProducts,
    setShowProducts,
    cart,
    selectedSaleType,
    setSelectedSaleType,
    selectProductCategory,
    restaurantProductCategory,
    productsData,
    pickProduct,
    handleAddOnModal,
    decreaseProductQty,
    deleteProduct,
    increaseProductQty,
    handleOrder,
    handleVoid,
    setAddCashFlag,
    setCashAddInFlag,
    selectedTable,
    setSelectedTable,
    setKeyValue,
    keyValue,
    paymentVisible,
    setPaymentVisible,
    setSelectedTable,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    addDefinedProductWithAddons,
    userPreferences,
    occupiedDataTablesData,
    setOcupiedTablesData,
    reservedTablesData,
    setReservedTablesData,
    saleTypeProducts,
    setSaleTypeProducts,
    paymentVisible,
    setNumb,
    processOrder,
    setDenaminationsKeyboard,
    denaminationsKeyboard,
    userData,
    tillValue,
    defaultCustomer,
    clearCartData,
    recordState,
    setRecardState,
    mainTableData,
    showSendToKitchen,
    setShowSendToKitchen,
    getSalesHistoryData,
    isPrintModeXML,
    upsertPOSLog,
    dateRange,
    setDateRange,
    getDisplayDate,
    content,
    searchHistoryInput,
    setSearchhistoryInput,
    ordersCopy,
    dateRef,
    filtersFlag,
    ...props,
  };
  const calls = [
    { name: "Rahul Verma", phone: "+91 98765 43210", city: "Bengaluru", loyalty: 420, holdTime: "4:05", priority: "HIGH" },
    { name: "Priya Sharma", phone: "+91 87654 32109", city: "Bengaluru", loyalty: 280, holdTime: "3:00", priority: "HIGH" },
    { name: "Amit Patel", phone: "+91 76543 21098", city: "Indiranagar", loyalty: 150, holdTime: "2:00", priority: "MEDIUM" },
    { name: "Neha Gupta", phone: "+91 65432 10987", city: "Koramangala", loyalty: 320, holdTime: "1:35", priority: "MEDIUM" },
    { name: "Vikram Singh", phone: "+91 54321 09876", city: "Whitefield", loyalty: 85, holdTime: "1:00", priority: "LOW" },
    { name: "Anjali Desai", phone: "+91 43210 98765", city: "HSR Layout", loyalty: 200, holdTime: "0:45", priority: "LOW" },
  ];

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#fff" }} spin />} spinning={false}>
      {syncLoad ? (
        <>
          <div style={{ backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%" }}>
            <Row style={{ height: "9vh", background: "", padding: "0.8% 0" }}>
              <Col span={6}>
                <img src={Logo} style={{ height: "2.8vw", paddingLeft: "1vw", paddingTop: "1vh" }} />
              </Col>
              <Col span={18} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "1vw", fontSize: "1vw" }}>
                <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{formattedDateTime}</div>
                <div style={{ fontWeight: 400, fontFamily: "Inter", fontSize: "1.2em", color: "#0F0718" }}>{clock1}</div>
              </Col>
            </Row>
            <div style={{ display: "flex", height: "90vh" }}>
              <div
                style={{
                  width: "48%",
                  background: "#fff",
                  height: "83vh",
                  margin: "1.5%",
                  marginRight: 0,
                  borderRadius: "10px",
                  alignItems: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "1vw" }}>
                  <div style={{ position: "relative", width: "13vw", height: "13vw" }}>
                    <img
                      src={leftLoading}
                      alt="Loading"
                      style={{
                        width: "100%",
                        height: "100%",
                        // transform: `rotate(${rotation}deg)`,
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "1.5em",
                        fontWeight: "500",
                        color: "#0F0718",
                      }}
                    >
                      {percent}
                    </div>
                  </div>
                  <p style={{ color: "#0F0718", fontFamily: "Inter", fontWeight: 500, fontSize: "2.5em", marginBottom: 0 }}>Till loading in process</p>
                  {/* <p style={{color:"#D73A48",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw",marginBottom:0}}>{formatTime(time)}</p>
           <p style={{color:"#0F0718",fontFamily:"Inter",fontWeight:500,fontSize:"1.5vw"}}>Minutes Left</p> */}
                </div>
              </div>
              <div style={{ width: "48%", height: "83vh", background: "#fff", margin: "1.5%", borderRadius: "10px", color: "#0F0718" }}>
                <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "17vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>
                  Product Categories
                </p>
                <Progress
                  strokeColor={{
                    from: "#2F3856",
                    to: "#2F3856",
                  }}
                  // showInfo={false}
                  style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                  percent={productCategoryPercentage}
                  status="active"
                />
                <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Products</p>
                <Progress
                  strokeColor={{
                    from: "#2F3856",
                    to: "#2F3856",
                  }}
                  // showInfo={false}
                  style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                  percent={productPercentage}
                  status="active"
                />
                <p style={{ fontFamily: "Inter", fontWeight: 500, fontSize: "1.2em", marginTop: "7vh", marginBottom: 0, padding: "0 2.5vw", color: "#0F0718" }}>Promotions</p>
                <Progress
                  strokeColor={{
                    from: "#2F3856",
                    to: "#2F3856",
                  }}
                  // showInfo={false}
                  style={{ padding: "0 2.5vw", fontSize: "1em", color: "#0F0718" }}
                  percent={promotionPercentage}
                  status="active"
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <div style={data.posScreenStyles.main}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                backgroundColor: "#fff",
                height: "100vh",
                width: "6.7%",
                boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.15)",
                paddingLeft: "0.5vw",
                paddingRight: "0.5vw",
                display: showOrderCompleteFlag ? "none" : "",
              }}
            >
              <Row style={{ fontSize: "1vw" }}>
                <Col span={24} style={{ marginTop: "1.4vh" }}>
                  <Tooltip>
                    <button
                      style={{
                        width: "100%",
                        background: "#fff",
                        color: "#ffffff",
                        border: "1px solid #fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img src={Logo} alt="remove" style={{ height: "4.5vw" }} />
                    </button>
                  </Tooltip>
                </Col>
                {!showMoreMenu ? (
                  <>
                    <Col id="step1" span={24} style={{ marginTop: "0.7vh", display: posConfig?.enableDineIn === "Y" ? "block" : "none" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          display: tillaccess?.dineIn === "Y" ? "block" : "none",
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          // display: accessController?.=== "N" ? "block" : "none",
                          ...(keyValue === "0"
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                              }
                            : { backgroundColor: "#fff", border: "1px solid #fff" }),
                        }}
                        onClick={async () => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (splitBillScreen) {
                            message.warning(messages.errors.cart.cart_switch_section);
                            return;
                          }
                          setShowProducts(false);
                          const selectedSaleTypeArray = await getSaleTypeArray("DI");
                          handleSelectedSaleTypeForProducts(selectedSaleTypeArray)();
                          const cartObj = JSON.parse(localStorage.getItem("cartObj"));
                          let updatedCart = {
                            ...cartObj,
                            customer: selectedSaleTypeArray.customer?.b2cCustomerId ? selectedSaleTypeArray.customer : tillData.tillAccess.csBunit.b2cCustomer,
                            sOrderID: uuidv4().replace(/-/g, "").toUpperCase(),
                            saleType: selectedSaleTypeArray?.cwrSaletype ?? {},
                          };
                          setCart(updatedCart);
                          localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                          setSaleType("DI");
                          handleKeyvalue("0");
                          setPaymentVisible(false);
                          setShowProducts(false);
                          // setSaleTypeProducts([]);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <TableDineIN color={keyValue === "0" ? "#FFF" : "#555359"} />
                          <span
                            className="posIcon"
                            style={{
                              color: keyValue === "0" ? "#fff" : "#555359",
                              fontWeight: 500,
                            }}
                          >
                            {getMultilingualText("Dine In")}
                          </span>
                        </div>
                      </button>
                    </Col>

                    <Col id="step4" span={24} style={{ marginTop: "1vh", display: posConfig?.enableTakeAway === "Y" ? "block" : "none" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "2" || (keyValue === "0" && posConfig?.enableDineIn === "N")
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                              }
                            : { backgroundColor: "#fff", border: "1px solid #fff" }),
                        }}
                        onClick={async () => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (splitBillScreen) {
                            message.warning(messages.errors.cart.cart_switch_section);
                            return;
                          }
                          setShowProducts(false);
                          const cartObj = JSON.parse(localStorage.getItem("cartObj"));
                          if (cartObj) {
                            cartObj.items = [];
                            localStorage.setItem("cartObj", JSON.stringify(cartObj));
                            setCart({ ...cartObj });
                          }
                          const selectedSaleTypeArray = await getSaleTypeArray("TA");
                          await handleSelectedSaleTypeForProducts(selectedSaleTypeArray)();
                          // const cartObj1 = JSON.parse(localStorage.getItem("cartObj"));
                          const cartObj1 = clearCartData;
                          let updatedCart = {
                            ...cartObj1,
                            documentno: `${tillData.tillAccess.cwrTill.prefix}${tillDocumentSequence + 1}`,
                            customer: selectedSaleTypeArray?.customer?.b2cCustomerId ? selectedSaleTypeArray?.customer : tillData.tillAccess.csBunit.b2cCustomer,
                            saleType: selectedSaleTypeArray?.cwrSaletype ?? {},
                          };
                          setCart(updatedCart);
                          localStorage.setItem("cartObj", JSON.stringify(updatedCart));
                          setSaleType("TA");
                          handleKeyvalue("2");
                          localStorage.setItem("dineIn", "N");
                          setPaymentVisible(false);
                          // setSaleTypeProducts([]);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <TableMenu color={keyValue === "2" || (keyValue === "0" && posConfig?.enableDineIn === "N") ? "#FFF" : "#555359"} />
                          <span className="posIcon" style={{ color: keyValue === "2" || (keyValue === "0" && posConfig?.enableDineIn === "N") ? "#fff" : "#555359" }}>
                            {getMultilingualText("Take Away")}
                          </span>
                        </div>
                      </button>
                    </Col>
                    <Col id="step2" span={24} style={{ marginTop: "1vh", display: posConfig?.enableHomeDelivery === "Y" ? "block" : "none" }}>
                      <button
                        className="cartMenuItems"
                        disabled={tillaccess?.dineIn === "Y" ? false : true}
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "1" || (keyValue === "0" && posConfig?.enableDineIn === "N" && posConfig?.enableTakeAway === "N")
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                                padding: "0",
                              }
                            : {
                                backgroundColor: "#fff",
                                border: "1px solid #fff",
                                padding: "0",
                              }),
                        }}
                        onClick={() => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (splitBillScreen) {
                            message.warning(messages.errors.cart.cart_switch_section);
                            return;
                          }
                          handleKeyvalue("1");
                          setSaleType("HD");
                          setPaymentVisible(false);
                          setShowProducts(false);
                          setSaleTypeProducts([]);
                          setIsCardPaymentFlag(false);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <TakeAway color={keyValue === "1" || (keyValue === "0" && posConfig?.enableDineIn === "N" && posConfig?.enableTakeAway === "N") ? "#FFF" : "#555359"} />
                          <span
                            className="posMenuIcons"
                            style={{
                              color: keyValue === "1" || (keyValue === "0" && posConfig?.enableDineIn === "N" && posConfig?.enableTakeAway === "N") ? "#fff" : "#555359",
                              paddingTop: "0px",
                            }}
                          >
                            {getMultilingualText("Home Delivery")}
                          </span>
                        </div>
                      </button>
                    </Col>

                    {/* <Col id="step3" span={24} style={{ marginTop: "1vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "5"
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                                padding: "0",
                              }
                            : {
                                backgroundColor: "#fff",
                                border: "1px solid #fff",
                                padding: "0",
                              }),
                        }}
                        onClick={() => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          handleKeyvalue("5");
                          setPaymentVisible(false);
                          setShowProducts(false);
                          setSaleTypeProducts([]);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <CashManagementIcon color={keyValue === "5" ? "#FFF" : "#555359"} />
                          <span
                            className="posMenuIcons"
                            style={{
                              color: keyValue === "5" ? "#fff" : "#555359",
                              paddingTop: "0px",
                            }}
                          >
                            {getMultilingualText("Cash Management")}
                          </span>
                        </div>
                      </button>
                    </Col> */}
                    {posConfig?.enableAggregator === "Y" && (
                      <Col id="aggregator" span={24} style={{ marginTop: "2vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                          }}
                          onClick={() => {
                            history.push("/aggregator");
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                            <img src={openDrawerIcon} style={{ height: "3vh" }} alt="" />
                            <span className="posIcon" style={{ color: "#555359" }}>
                              Aggregator
                            </span>
                          </div>
                        </button>
                      </Col>
                    )}
                    {!multilingual && (
                      <Col id="step5" span={24} style={{ marginTop: "2vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "6"
                              ? {
                                  backgroundColor: "#2F3856",
                                  border: "1px solid #2F3856",
                                  padding: "0",
                                }
                              : {
                                  backgroundColor: "#fff",
                                  border: "1px solid #fff",
                                  padding: "0",
                                }),
                          }}
                          onClick={async () => {
                            const tables = await db.tableData.toArray();
                            const hasPendingBill = tables.some((table) => table.statusType === "OCU");

                            if (hasPendingBill) {
                              message.warning("Please complete the bill to proceed to Product sync", { duration: 10 });
                              return;
                            }
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (splitBillScreen) {
                              message.warning(messages.errors.cart.cart_switch_section);
                              return;
                            }
                            handleKeyvalue("6");
                            setSyncLoad(true);
                            localStorage.removeItem("lastUpdatedTime");
                            let tillData = JSON.parse(localStorage.getItem("tillData"));
                            await processSync(tillData, setGlobalStore, "Incremental Sync");
                            setSyncLoad(false);
                            setGlobalStore({ percent: "0%" });
                            setGlobalStore({ productCategoryPercentage: "0" });
                            setGlobalStore({ productPercentage: "0" });
                            setGlobalStore({ promotionPercentage: "0" });
                            window.location.reload();
                            setKeyValue("0");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                            <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                              {getMultilingualText("Product Sync")}
                            </span>
                          </div>
                        </button>
                      </Col>
                    )}
                    <Col id="step4" span={24} style={{ marginTop: "1vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "3"
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                                padding: "0",
                              }
                            : {
                                backgroundColor: "#fff",
                                border: "1px solid #fff",
                                padding: "0",
                              }),
                        }}
                        onClick={async () => {
                          setLoading(true); // Show loader immediately

                          try {
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (splitBillScreen) {
                              message.warning(messages.errors.cart.cart_switch_section);
                              return;
                            }
                            handleKeyvalue("3");
                            setShowOrderCompleteFlag(false);
                            // deleteCart();
                            setPaymentVisible(false);
                            setShowProducts(false);
                            setSaleTypeProducts([]);
                            setCart(clearCartData);
                            localStorage.setItem("cartObj", JSON.stringify(clearCartData));
                            setSearchhistoryInput("");
                            setOrderHistoryDetails([]);
                            setFiltersFlag(false);
                            const dateValue = [moment(new Date()), moment(new Date())];
                            setOrderHistoryDetails([]);

                            // Await if searchOrderHistory is async
                            await searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
                          } catch (error) {
                            console.error("Error processing click:", error);
                          } finally {
                            setLoading(false);
                          }
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <TableOrder color={keyValue === "3" ? "#FFF" : "#fff"} />
                          <span className="posIcon" style={{ color: keyValue === "3" ? "#fff" : "#555359" }}>
                            {getMultilingualText("History")}
                          </span>
                        </div>
                      </button>

                      {loading && (
                        <div
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.3)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10000,
                          }}
                        >
                          <Spin size="large" />
                        </div>
                      )}
                    </Col>

                    <Col id="moreMenuButton" span={24} style={{ marginTop: "1vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                        }}
                        onClick={() => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (splitBillScreen) {
                            message.warning(messages.errors.cart.cart_switch_section);
                            return;
                          }
                          setShowMoreMenu(!showMoreMenu);
                          //  setKeyValue("0");
                        }}
                      >
                        <div>
                          <MoreOutlined style={{ color: "#555359" }} />
                          {/* <span className="posIcon" style={{ color: "#555359" }}>...</span> */}
                        </div>
                      </button>
                    </Col>
                  </>
                ) : (
                  <>
                    {multilingual && (
                      <Col id="step5" span={24} style={{ marginTop: "1.5vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "6"
                              ? {
                                  backgroundColor: "#2F3856",
                                  border: "1px solid #2F3856",
                                  padding: "0",
                                }
                              : {
                                  backgroundColor: "#fff",
                                  border: "1px solid #fff",
                                  padding: "0",
                                }),
                          }}
                          onClick={async () => {
                            if (cart.paid > 0) {
                              message.warning(`${messages.errors.till_management.delete_payment_method}`);
                              return;
                            }
                            if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            if (showSendToKitchen) {
                              message.warning(`${messages.errors.cart.cart_switch_section}`);
                              return;
                            }
                            handleKeyvalue("6");
                            setSyncLoad(true);
                            localStorage.removeItem("lastUpdatedTime");
                            let tillData = JSON.parse(localStorage.getItem("tillData"));
                            await processSync(tillData, setGlobalStore, "Incremental Sync");
                            setSyncLoad(false);
                            setGlobalStore({ percent: "0%" });
                            setGlobalStore({ productCategoryPercentage: "0" });
                            setGlobalStore({ productPercentage: "0" });
                            setGlobalStore({ promotionPercentage: "0" });
                            window.location.reload();
                            setKeyValue("0");
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                            <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                              {getMultilingualText("Product Sync")}
                            </span>
                          </div>
                        </button>
                      </Col>
                    )}

                    <Col id="unlinkTill" span={24} style={{ marginTop: "2vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(isUnlinkTillClicked
                            ? {
                                backgroundColor: "#2F3856", // Active background color
                                border: "1px solid #2F3856",
                              }
                            : {
                                backgroundColor: "#fff", // Default background color
                                border: "1px solid #fff",
                              }),
                        }}
                        onClick={handleUnlinkTillClick}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img
                            src={unlinkTill}
                            style={{
                              height: "3vh",
                              filter: isUnlinkTillClicked
                                ? "brightness(0) invert(1)" // Makes the icon white when clicked
                                : "none", // Default icon color
                            }}
                            alt="unlink till"
                          />
                          <span
                            className="posMenuIcons"
                            style={{
                              color: isUnlinkTillClicked ? "#fff" : "#555359", // White text color when clicked, default otherwise
                            }}
                          >
                            {getMultilingualText("Unlink Till")}
                          </span>
                        </div>
                      </button>
                    </Col>

                    <Col id="step5" span={24} style={{ marginTop: "0.5vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "6"
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                                padding: "0",
                              }
                            : {
                                backgroundColor: "#fff",
                                border: "1px solid #fff",
                                padding: "0",
                              }),
                        }}
                        onClick={async () => {
                          const tables = await db.tableData.toArray();
                          const hasPendingBill = tables.some((table) => table.statusType === "OCU");

                          if (hasPendingBill) {
                            message.warning("Please complete the bill to proceed to Full sync", { duration: 10 });
                            return;
                          }
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          handleKeyvalue("6");
                          setSyncLoad(true);
                          localStorage.removeItem("lastUpdatedTime");
                          let tillData = JSON.parse(localStorage.getItem("tillData"));
                          await processSync(tillData, setGlobalStore, "Full Sync");
                          setSyncLoad(false);
                          setGlobalStore({ percent: "0%" });
                          setGlobalStore({ productCategoryPercentage: "0" });
                          setGlobalStore({ productPercentage: "0" });
                          setGlobalStore({ promotionPercentage: "0" });
                          window.location.reload();
                          setKeyValue("0");
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <SyncIcon color={keyValue === "6" ? "#FFF" : "#555359"} />
                          <span className="posMenuIcons" style={{ color: keyValue === "6" ? "#fff" : "#555359" }}>
                            {getMultilingualText("Full Sync")}
                          </span>
                        </div>
                      </button>
                    </Col>

                    {/* <Col id="printReceipt" span={24} style={{ marginTop: "2vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                          <img src={printerIcon} style={{ height: "3vh" }} alt="" />
                          <span className="posIcon" style={{ color: "#555359" }}>
                            {getMultilingualText("Print")}{" "}
                          </span>
                        </div>
                      </button>
                    </Col> */}
                    <Col id="step4" span={24} style={{ marginTop: "0.5vh", display: posConfig?.showCustomers === "Y" ? "block" : "none" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "8"
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                                padding: "0",
                              }
                            : {
                                backgroundColor: "#fff",
                                border: "1px solid #fff",
                                padding: "0",
                              }),
                        }}
                        onClick={() => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (splitBillScreen) {
                            message.warning(messages.errors.cart.cart_switch_section);
                            return;
                          }
                          handleKeyvalue("8");
                          setPaymentVisible(false);
                          setShowProducts(false);
                          setSaleTypeProducts([]);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <TableCustomer color={keyValue === "8" ? "#FFF" : "#555359"} />
                          <span className="posIcon" style={{ color: keyValue === "8" ? "#fff" : "#555359" }}>
                            {getMultilingualText("Customers")}
                          </span>
                        </div>
                      </button>
                    </Col>
                    <Col id="step3" span={24} style={{ marginTop: "3.5vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "5"
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                                padding: "0",
                              }
                            : {
                                backgroundColor: "#fff",
                                border: "1px solid #fff",
                                padding: "0",
                              }),
                        }}
                        onClick={() => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (splitBillScreen) {
                            message.warning(messages.errors.cart.cart_switch_section);
                            return;
                          }
                          handleKeyvalue("5");
                          setPaymentVisible(false);
                          setShowProducts(false);
                          setSaleTypeProducts([]);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <CashManagementIcon color={keyValue === "5" ? "#FFF" : "#555359"} />
                          <span
                            className="posMenuIcons"
                            style={{
                              color: keyValue === "5" ? "#fff" : "#555359",
                              paddingTop: "0px",
                            }}
                          >
                            {getMultilingualText("Cash Management")}
                          </span>
                        </div>
                      </button>
                    </Col>
                    <Col
                      id="salesReport"
                      span={24}
                      onClick={async () => {
                        try {
                          let ordersData = await db.ordersData.toArray();
                          ordersData = ordersData.filter((data) => data.tillStatus === "open");

                          if (CWHardwareController && typeof salesReportCWHCPrinter === "function") {
                            await salesReportCWHCPrinter(ordersData);
                          } else if (typeof salesReportPrinter === "function") {
                            await salesReportPrinter(ordersData);
                          } else {
                            console.error("Sales report printer functions not found");
                          }
                        } catch (err) {
                          console.error("Error while printing sales report:", err);
                        }
                      }}
                      style={{
                        cursor: "pointer",
                        display: tillData?.tillAccess?.salesReport === "Y" ? "block" : "none",
                        marginTop: "2vh",
                      }}
                    >
                      <button
                        className="cartMenuItems"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <img src={salesReportIcon} style={{ height: "3vh" }} alt="sales report" />
                          <span className="posIcon" style={{ color: "#555359" }}>
                            {getMultilingualText("Sales Report")}
                          </span>
                        </div>
                      </button>
                    </Col>
                    {posConfig?.enableCallCentre === "Y" && (
                      <Col span={24} style={{ marginTop: "0.5vh", display: "block" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                            ...(keyValue === "9"
                              ? { backgroundColor: "#2F3856", border: "1px solid #2F3856", padding: "0" }
                              : { backgroundColor: "#fff", border: "1px solid #fff", padding: "0" }),
                          }}
                          onClick={async () => {
                            try {
                              // ----- 1. Guard clauses (keep them) -----
                              if (cart.paid > 0) {
                                message.warning(`${messages.errors.till_management.delete_payment_method}`);
                                return;
                              }
                              if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                                message.warning(`${messages.errors.cart.cart_switch_section}`);
                                return;
                              }
                              if (showSendToKitchen || splitBillScreen) {
                                message.warning(messages.errors.cart.cart_switch_section);
                                return;
                              }
                              setIsCallCenterFlow(true); // <-- this triggers the centered page
                              setShowCallCenterPage(true); // (optional) reset any other UI flags you use
                              // setKeyValue("10");
                              history.push("/call-center");
                            } catch (error) {
                              console.error("Call Center button error:", error);
                              message.error("An error occurred while switching to Call Center mode");
                            }
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <CustomerServiceOutlined style={{ color: keyValue === "9" ? "#FFF" : "#555359", fontSize: "3vh" }} />
                            <span className="posIcon" style={{ color: keyValue === "9" ? "#fff" : "#555359" }}>
                              {getMultilingualText("Call Center")}
                            </span>
                          </div>
                        </button>
                      </Col>
                    )}
                    {/* {posConfig?.enableAggregator === "Y" && (
                      <Col id="aggregator" span={24} style={{ marginTop: "2vh" }}>
                        <button
                          className="cartMenuItems"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #fff",
                          }}
                          onClick={() => {
                            history.push("/aggregator");
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                            <img src={openDrawerIcon} style={{ height: "3vh" }} alt="" />
                            <span className="posIcon" style={{ color: "#555359" }}>
                              Aggregator
                            </span>
                          </div>
                        </button>
                      </Col>
                    )} */}
                    {/* <Col id="step3" span={24} style={{ marginTop: "1vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          ...(multilingual ? { height: "auto", minHeight: "10.2vh" } : { height: "4.2vw", minHeight: "4.2vh" }),
                          ...(keyValue === "5"
                            ? {
                                backgroundColor: "#2F3856",
                                border: "1px solid #2F3856",
                                padding: "0",
                              }
                            : {
                                backgroundColor: "#fff",
                                border: "1px solid #fff",
                                padding: "0",
                              }),
                        }}
                        onClick={() => {
                          if (cart.paid > 0) {
                            message.warning(`${messages.errors.till_management.delete_payment_method}`);
                            return;
                          }
                          if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          if (showSendToKitchen) {
                            message.warning(`${messages.errors.cart.cart_switch_section}`);
                            return;
                          }
                          handleKeyvalue("5");
                          setPaymentVisible(false);
                          setShowProducts(false);
                          setSaleTypeProducts([]);
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                        >
                          <CashManagementIcon color={keyValue === "5" ? "#FFF" : "#555359"} />
                          <span
                            className="posMenuIcons"
                            style={{
                              color: keyValue === "5" ? "#fff" : "#555359",
                              paddingTop: "0px",
                            }}
                          >
                            {getMultilingualText("Cash Management")}
                          </span>
                        </div>
                      </button>
                    </Col> */}

                    {/* Back Button to return to Main Menu */}
                    <Col id="backButton" span={24} style={{ marginTop: "2vh" }}>
                      <button
                        className="cartMenuItems"
                        style={{
                          backgroundColor: "#fff",
                          border: "1px solid #fff",
                        }}
                        onClick={() => setShowMoreMenu(false)}
                      >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                          {/* <BackIcon color="#555359" /> */}
                          <ArrowLeftOutlined style={{ color: "#555359" }} />
                          <span className="posIcon" style={{ color: "#555359" }}>
                            {getMultilingualText("Back")}
                          </span>
                        </div>
                      </button>
                    </Col>
                    {/* <Col span={24} style={{ marginTop: "32vh" }}></Col> */}
                  </>
                )}
              </Row>
              <Col span={24} style={{ position: "absolute", bottom: 0, marginLeft: "0.5vw" }}>
                <div id="step6">
                  <button
                    className="cartMenuItems"
                    style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
                    onClick={() => {
                      if (cart.paid > 0) {
                        message.warning(`${messages.errors.till_management.delete_payment_method}`);
                        return;
                      }
                      if (cart.items.length > 0 && localStorage.getItem("dineIn") === "N") {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      if (showSendToKitchen) {
                        message.warning(`${messages.errors.cart.cart_switch_section}`);
                        return;
                      }
                      let posConfig = JSON.parse(localStorage.getItem("posConfig"));
                      if (posConfig?.shiftClose === "Y") {
                        if (posConfig?.showDenominations === "Y") {
                          history.push("/close-till");
                        } else if (posConfig?.showDenominations === "N") {
                          history.push("/close-till-all");
                        }
                      } else {
                        history.push("/");
                      }
                      handleKeyvalue("8");
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                      }}
                    >
                      <img src={Logout} style={{ height: "7vh" }} />
                    </div>
                  </button>
                </div>
              </Col>
            </div>

            <div style={{ width: "100%" }}>
              {keyValue === "0" ? (
                posConfig?.enableDineIn === "Y" ? (
                  <TableManagement
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    addDefinedProductWithAddons={addDefinedProductWithAddons}
                    restaurantProductCategory={restaurantProductCategory}
                    productsData={productsData}
                    pickProduct={pickProduct}
                    increaseProductQty={increaseProductQty}
                    decreaseProductQty={decreaseProductQty}
                    deleteProduct={deleteProduct}
                    setDisplayCustomerSearch={setDisplayCustomerSearch}
                    handleVoid={handleVoid}
                    paymentVisible={paymentVisible}
                    setPaymentVisible={setPaymentVisible}
                    cart={cart}
                    setCart={setCart}
                    deleteCart={deleteCart}
                    setKeyValue={setKeyValue}
                    handleOrder={handleOrder}
                    showProducts={showProducts}
                    setShowProducts={setShowProducts}
                    tableCards={tableCards}
                    setTableCards={setTableCards}
                    occupiedDataTablesData={occupiedDataTablesData}
                    setOcupiedTablesData={setOcupiedTablesData}
                    reservedTablesData={reservedTablesData}
                    setReservedTablesData={setReservedTablesData}
                    setProductsData={setProductsData}
                    saleTypeProducts={saleTypeProducts}
                    setSaleTypeProducts={setSaleTypeProducts}
                    requestPayment={requestPayment}
                    showOrderCompleteFlag={showOrderCompleteFlag}
                    setShowOrderCompleteFlag={setShowOrderCompleteFlag}
                    handleCashPayment={handleCashPayment}
                    mainTableData={mainTableData}
                    setMainTableData={setMainTableData}
                  />
                ) : posConfig?.enableTakeAway === "Y" ? (
                  <MenuLayout
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    setProductsData={setProductsData}
                    showSendToKitchen={showSendToKitchen}
                    setShowSendToKitchen={setShowSendToKitchen}
                    selectedProductForNotes={selectedProductForNotes}
                    notesValue={notesValue}
                    setNotesValue={setNotesValue}
                    setIsInputFocused={setIsInputFocused}
                    keyboardRef={keyboardRef}
                    setSelectedProductForNotes={setSelectedProductForNotes}
                  />
                ) : (
                  <HomeDeliveryComponent
                    {...tableLayoutProps}
                    categorieFlag={categorieFlag}
                    setCategorieFlag={setCategorieFlag}
                    addDefinedProductWithAddons={addDefinedProductWithAddons}
                    restaurantProductCategory={restaurantProductCategory}
                    productsData={productsData}
                    pickProduct={pickProduct}
                    increaseProductQty={increaseProductQty}
                    decreaseProductQty={decreaseProductQty}
                    deleteProduct={deleteProduct}
                    setDisplayCustomerSearch={setDisplayCustomerSearch}
                    handleVoid={handleVoid}
                    setPaymentVisible={setPaymentVisible}
                    showProducts={showProducts}
                    setShowProducts={setShowProducts}
                    isSaleTypeFlag={isSaleTypeFlag}
                    setIsSaleTypeFlag={setIsSaleTypeFlag}
                    setProductsData={setProductsData}
                  />
                )
              ) : keyValue === "3" ? (
                <OrderListComponent {...tableLayoutProps} setSearchhistoryInput={setSearchhistoryInput} />
              ) : keyValue === "5" ? (
                <CashManagement {...tableLayoutProps} />
              ) : keyValue === "8" ? (
                <CustomersComponent {...tableLayoutProps} />
              ) : keyValue === "2" ? (
                <MenuLayout
                  {...tableLayoutProps}
                  categorieFlag={categorieFlag}
                  setCategorieFlag={setCategorieFlag}
                  addDefinedProductWithAddons={addDefinedProductWithAddons}
                  cart={cart}
                  setCart={setCart}
                  setProductsData={setProductsData}
                  showSendToKitchen={showSendToKitchen}
                  setShowSendToKitchen={setShowSendToKitchen}
                  selectedProductForNotes={selectedProductForNotes}
                  notesValue={notesValue}
                  setNotesValue={setNotesValue}
                  setIsInputFocused={setIsInputFocused}
                  keyboardRef={keyboardRef}
                  setSelectedProductForNotes={setSelectedProductForNotes}
                />
              ) : keyValue === "1" ? (
                <HomeDeliveryComponent
                  {...tableLayoutProps}
                  categorieFlag={categorieFlag}
                  setCategorieFlag={setCategorieFlag}
                  addDefinedProductWithAddons={addDefinedProductWithAddons}
                  restaurantProductCategory={restaurantProductCategory}
                  productsData={productsData}
                  pickProduct={pickProduct}
                  increaseProductQty={increaseProductQty}
                  decreaseProductQty={decreaseProductQty}
                  deleteProduct={deleteProduct}
                  setDisplayCustomerSearch={setDisplayCustomerSearch}
                  handleVoid={handleVoid}
                  setPaymentVisible={setPaymentVisible}
                  showProducts={showProducts}
                  setShowProducts={setShowProducts}
                  isSaleTypeFlag={isSaleTypeFlag}
                  setIsSaleTypeFlag={setIsSaleTypeFlag}
                  setProductsData={setProductsData}
                />
              ) : null}
            </div>
          </div>
        </div>
      )}
      <RestaurantModals
        selectedTable={selectedTable}
        orderFlags={orderFlags}
        setOrderFlags={setOrderFlags}
        getCustomerData={getCustomerData}
        tableList={tableList}
        setTableList={setTableList}
        displayAddOnSelection={displayAddOnSelection}
        handleAddOnModalClose={handleAddOnModalClose}
        addOnsList={addOnsList}
        selectedProduct={selectedProduct}
        selectedAddons={selectedAddons}
        handleAddOnValue={handleAddOnValue}
        currencyType={currencyType}
        selectedRowKeys={selectedRowKeys}
        selectedProductInCart={selectedProductInCart}
        decreaseProductQty={decreaseProductQty}
        handleQty={handleQty}
        increaseProductQty={increaseProductQty}
        handleAdd={handleAdd}
        selectedItemsModalOpen={selectedItemsModalOpen}
        setSelectedItemsModalOpen={setSelectedItemsModalOpen}
        selectProductInCart={selectProductInCart}
        handleDisplayOk={handleDisplayOk}
        displayOrderItemsModal={displayOrderItemsModal}
        orderStatus={orderStatus}
        selectedOrderStatus={selectedOrderStatus}
        handleOrderStatusSelection={handleOrderStatusSelection}
        handleOrderStatus={handleOrderStatus}
        setDisplayOrderItemsModal={setDisplayOrderItemsModal}
        orderDetails={orderDetails}
        handleStatusButton={handleStatusButton}
        barcodeOrderStatusModal={barcodeOrderStatusModal}
        setBarcodeOrderStatusModal={setBarcodeOrderStatusModal}
        barcodeOrderList={barcodeOrderList}
        handleBarcodeOrderPrint={handleBarcodeOrderPrint}
        handleAccept={handleAccept}
        cart={cart}
        tillData={tillData}
        openPaymentModal={openPaymentModal}
        billConfirmationModalOpen={billConfirmationModalOpen}
        setBillConfirmationModalOpen={setBillConfirmationModalOpen}
        parkedList={parkedList}
        openDisplayParkedBillModal={openDisplayParkedBillModal}
        orderTypeSelection={orderTypeSelection}
        manualDiscountModalVisible={manualDiscountModalVisible}
        setManualDiscountInput={setManualDiscountInput}
        setManualDiscountModalVisible={setManualDiscountModalVisible}
        notesModalOpen={notesModalOpen}
        setNotesModalOpen={setNotesModalOpen}
        handleCancelOrder={handleCancelOrder}
        showSendToKitchen={showSendToKitchen}
        setShowSendToKitchen={setShowSendToKitchen}
      />
      <RetailModals {...props} />
    </Spin>
  );
};
export default FBLayout;
